<dx-popup
    #alertsPopup
    [minWidth]="isSmallScreen ? popupWidth : undefined"
    [minHeight]="isSmallScreen ? popupHeight : undefined"
    [maxWidth]="!isSmallScreen ? popupWidth : undefined"
    [maxHeight]="!isSmallScreen ? popupHeight : undefined"
    [showTitle]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="true"
    [showCloseButton]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'title'" class="community-owner-alerts-title">
        <dx-box width="100%" direction="row">
            <dxi-item [ratio]="1">
                <dx-tabs
                    class="cc-tabs"
                    width="100%"
                    [visible]="viewModes.length > 1"
                    [dataSource]="viewModes"
                    [(selectedIndex)]="selectedViewIndex"
                    (onItemClick)="onTabItemClick($event)"
                ></dx-tabs>
                <div *ngIf="viewModes.length === 1">
                    <h4 class="popup-title-text">{{ viewModes[0].text }}</h4>
                </div>
            </dxi-item>
            <dxi-item baseSize="10"></dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="page-help-link">
                    <a [href]="helpLink" target="_blank" class="fas fa-2x fa-question-circle"></a>
                </div>
            </dxi-item>
            <dxi-item baseSize="50"></dxi-item>
            <dxi-item baseSize="auto">
                <dx-button type="normal" stylingMode="text" [icon]="iconClose" (onClick)="onHidden()"></dx-button>
            </dxi-item>
        </dx-box>
    </div>
    <div *dxTemplate="let item of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="box1">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <app-community-owner-alerts-list
                        #alertsList
                        [allowAdd]="selectedTabData?.allowAdd"
                        [isOwnerContext]="isOwnerContext"
                        (onSuccess)="onSaveOrUpdate()"
                    ></app-community-owner-alerts-list>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
